import {Card, compareCards} from '../../../../utils/Deck'
import {MoveCard} from '../../../../types/MoveCard'
import {sortCardsByWeight} from './sortCardsByWeight'

// Возвращает карты которыми можно покрыть первую не битую карту на столе
export function getProtectionCards(
    hand: Card[],
    battle: Card[][],
    trump: Card,
    onlyOne: boolean = false
): MoveCard[] {
    let cards: MoveCard[] = []

    hand = sortCardsByWeight(hand.slice(), trump)

    for (let k = 0; k < battle.length; k++) {
        if (battle[k].length === 1) {
            let battleCard = battle[k][0]

            for (let i = 0; i < hand.length; i++) {
                let myCard = hand[i]

                if (compareCards(battleCard, myCard, trump)) {
                    cards.push({card: myCard, index: k})

                    if (onlyOne) {
                        return cards
                    }
                }
            }
            break
        }
    }
    return cards
}
